import { render, staticRenderFns } from "./AuthSuccess.vue?vue&type=template&id=66cdf934&scoped=true"
import script from "./AuthSuccess.vue?vue&type=script&lang=js"
export * from "./AuthSuccess.vue?vue&type=script&lang=js"
import style0 from "./AuthSuccess.vue?vue&type=style&index=0&id=66cdf934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cdf934",
  null
  
)

export default component.exports